function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { FC } from 'react';
import cn from 'classnames';
import { ITextInputPins } from '../TextInput';
require("./TextInput-Box.css");
var styles = {
  "Root": "TextInput-Box-module-Root_1Cv",
  "brickRoundPin": "TextInput-Box-module-brickRoundPin_xY1",
  "clearClearPin": "TextInput-Box-module-clearClearPin_1b5",
  "clearRoundPin": "TextInput-Box-module-clearRoundPin_1Wk",
  "roundBrickPin": "TextInput-Box-module-roundBrickPin_308",
  "roundClearPin": "TextInput-Box-module-roundClearPin_2au"
};
export const TextInputBox = ({
  className,
  pin,
  ...props
}) => /*#__PURE__*/React.createElement("span", _extends({}, props, {
  className: cn(styles.Root, styles[`${pin}Pin`], className)
}));